import { useEffect, useRef } from 'react';
import type { SheetRef } from 'react-modal-sheet';
import { Outlet } from 'react-router';
import { SNAP_POINTS } from '@/shared/consts';
import { bottomSheetTypes, useBoundStore } from '@/shared/store';
import { BottomSheet } from '@/shared/ui';

const BottomSheetPage = () => {
	const sheetRef = useRef<SheetRef>(null);
	const dispatch = useBoundStore((store) => store.dispatch);
	const currentSnapPoint = useBoundStore((store) => store.currentSnapPoint);

	console.log(currentSnapPoint);

	useEffect(() => {
		if (!currentSnapPoint) return;
		sheetRef.current?.snapTo(currentSnapPoint);
	}, [currentSnapPoint]);

	return (
		<BottomSheet
			ref={sheetRef}
			isOpen={true}
			snapPoint={SNAP_POINTS}
			onSnapChange={(snapPoint) =>
				dispatch({ type: bottomSheetTypes.moveBottomSheet, snapPoint })
			}
		>
			<Outlet />
		</BottomSheet>
	);
};

export default BottomSheetPage;
